<template>
  <v-menu
    v-model="menu"
    light
    offset-y
    transition="slide-y-transition"
    :close-on-content-click="false"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        icon
        :loading="loading"
      >
        <v-icon v-text="icons.search" />
      </v-btn>
    </template>
    <v-card width="260">
      <v-card-title v-text="__('searchOrder')" />
      <v-card-text>
        <v-text-field
          v-model="value"
          ref="searchField"
          type="number"
          min="1"
          outlined
          hide-details
          :prepend-inner-icon="icons.hash"
          @keyup.enter="search()"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-text="__('cancel')"
          text
          color="grey darken-1"
          :disabled="loading"
          @click="cancel()"
        />
        <v-spacer />
        <v-btn
          v-text="__('search')"
          text
          color="primary"
          :disabled="loading"
          @click="search()"
        />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    data: () => ({
      menu: false,
      value: null,
    }),

    computed: {
      ...mapState('history', [
        'loading',
      ]),
    },

    watch: {
      menu (show) {
        if (show) {
          setTimeout(() => this.$refs.searchField.focus(), 50)
        }
      },
    },

    methods: {
      ...mapActions('history', [
        'searchOrder',
      ]),
      close () {
        this.menu = false
      },
      cancel () {
        this.value = null
        this.close()
      },
      search () {
        const id = this.value?.replace(/[-,.e]/, '')
        if (id) {
          this.searchOrder(id)
          this.close()
        }
      },
    },
  }
</script>
